import baratheonBanner from "@/assets/leaderboard/houses/baratheon-banner.webp";
import lannisterBanner from "@/assets/leaderboard/houses/lannister-banner.webp";
import starkBanner from "@/assets/leaderboard/houses/stark-banner.webp";
import targaryenBanner from "@/assets/leaderboard/houses/targaryen-banner.webp";
import { Column, Row } from "@/components";
import { cn } from "@/lib/utils";

const HOUSE_PENNANTS = [
  { image: starkBanner, drape: "-rotate-2", length: "h-[88%]" },
  { image: lannisterBanner, drape: "rotate-1", length: "h-full" },
  { image: targaryenBanner, drape: "-rotate-1", length: "h-full" },
  { image: baratheonBanner, drape: "rotate-2", length: "h-[88%]" },
];

export const HousePennants = ({ className }: { className?: string }) => {
  /* Render */
  const render = () => (
    <Column
      className={cn(
        "pointer-events-none relative isolate h-24 w-56 shrink-0 select-none",
        className,
      )}
    >
      <Row className="absolute inset-x-0 top-0 z-10 h-1 rounded-full border-t border-stone-300/70 bg-gradient-to-b from-stone-500 via-stone-600 to-stone-900 shadow-sm">
        <Row className="absolute -left-1 -top-0.5 h-2 w-2 rounded-full border border-stone-400 bg-gradient-to-br from-stone-300 to-stone-700" />
        <Row className="absolute -right-1 -top-0.5 h-2 w-2 rounded-full border border-stone-400 bg-gradient-to-br from-stone-300 to-stone-700" />
      </Row>
      <Row className="h-full items-start justify-between gap-2 px-2 pt-0.5">
        {HOUSE_PENNANTS.map(({ image, drape, length }) => (
          <Column
            className={cn(
              "relative min-w-0 flex-1 origin-top drop-shadow-[2px_4px_3px_rgba(0,0,0,0.4)]",
              drape,
              length,
            )}
            key={image}
          >
            <Column
              className="relative h-full overflow-hidden bg-stone-950"
              style={{
                clipPath: "polygon(0 0, 100% 0, 100% 86%, 50% 100%, 0 86%)",
              }}
            >
              <img
                alt=""
                className="absolute inset-0 h-full w-full object-cover object-top"
                draggable={false}
                src={image}
              />
              <Row className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.3),transparent_25%,rgba(255,255,255,0.13)_46%,rgba(0,0,0,0.22)_60%,transparent_80%)]" />
              <Row className="absolute inset-x-0 top-0 h-1 border-b border-amber-100/30 bg-black/30" />
            </Column>
          </Column>
        ))}
      </Row>
    </Column>
  );

  return render();
};
